export default __webpack_public_path__ + "static/media/border-bg-sm.293119a5.png";